<template>
    <div class="main">
     <news-list :url="url"></news-list>
    </div>
</template>

<script>
  import newsList from './newsLists/newsList.vue'

  export default {
    name: "industryTalk",
    data() {
      return {
        brand: '',
        tool:'',
        url:'IndustryTalk'
      }
    },
    components:{newsList},
    created: function () {
      sessionStorage.removeItem('tutorialHover');
    },
    methods: {
      // 品牌筛选项高亮
      handelBrandHover(name) {
        this.brand = name;
      },
      // 工具筛选项高亮
      handelToolHover(name) {
        this.tool = name;
      },
    }
  }
</script>

<style scoped>
  .main {
    width: 1170px;
    margin: auto auto 15px auto;
    min-height: calc(100% - 486px);
  }

  @media screen and (max-width: 1024px) {
    .main {
      width: 100%;
    }

  }

  </style>



// WEBPACK FOOTER //
// src/components/industryTalk.vue